import type { ToolDef } from '../utils/tools';

interface ExecutionBadgeProps {
  execution: ToolDef['execution'];
}

const DETAILS: Record<Exclude<ToolDef['execution'], 'local'>, { label: string; description: string }> = {
  hybrid: {
    label: 'Hybrid',
    description: 'Includes local processing and optional network requests',
  },
};

export function ExecutionBadge({ execution }: ExecutionBadgeProps) {
  if (execution === 'local') return null;

  const detail = DETAILS[execution];

  return (
    <span
      className="shrink-0 rounded border border-amber-400/30 bg-amber-500/10 px-1.5 py-0.5 text-[9px] font-medium uppercase tracking-wider text-amber-200"
      aria-label={`Execution: ${detail.label}. ${detail.description}`}
      title={detail.description}
    >
      {detail.label}
    </span>
  );
}
